const jwt_customizer = {
    general: '自定義 JWT 標記時發生錯誤。請稍後再試。',
    can_not_create_for_admin_tenant: '無法為管理租戶創建 JWT 標記自定義器。',
};
export default Object.freeze(jwt_customizer);
